export default {
  error: 'Fout',
  sorry: 'Sorry, we hebben de volgende fout ontvangen',
  workingOnIt:
    'Een ingenieur is hiervan op de hoogte gesteld en we werken eraan om het zo snel mogelijk op te lossen.',
  tryAgain: 'Probeer het later nogmaals',
  noInternet:
    'Er lijkt een probleem te zijn met uw internetverbinding. Controleer en probeer het opnieuw.',
}
